import { User } from '../users/user.class';

export class Login {
  constructor(
    public email?: string,
    public password?: string,
    public scope: string = 'web',
  ) {}
}
